import {Component} from "@angular/core";

@Component({
  selector: "common-ngswitch",
  template: `
  <usecase-container title="NgSwitch" src="common/ngswitch">
    <usecase-content>
      <select [value]="selected" (change)="selected = $event.target.value">
        <option value="A">A</option>
        <option value="B">B</option>
        <option value="X">X</option>
      </select>
      <div [ngSwitch]="selected">
        <template [ngSwitchWhen]="'A'">
          <b>A</b>
        </template>
        <template [ngSwitchWhen]="'B'">
          <b>B</b>
        </template>
        <template ngSwitchDefault>
          <b>Default</b>
        </template>
      </div>
    </usecase-content>
  </usecase-container>
  `
})
export class NgSwitchComponent {
  selected = "B";
}



/** WEBPACK FOOTER **
 ** ./script/common/ngswitch/component.ts
 **/